// src/utils/eip712.js
/* eslint-disable no-undef */

const ITEM_ID_KEY =
  (typeof process !== 'undefined' && process?.env?.REACT_APP_EIP712_ITEM_ID_KEY) || 'ticketType';

export function getDomain(chainId, verifyingContract) {
  return {
    name: 'EventTicketWithEvents',
    version: '1',
    chainId: Number(chainId),
    verifyingContract,
  };
}

/** Текущий ключ ID (для сортировки/логов) */
export function getItemIdKey() {
  return ITEM_ID_KEY;
}
